import { CurrencyText } from "@/components/common/text";
import { ConfidenceLevel } from "@/components/common/svgs/ConfidenceLevel";
import { setInputSearch, toggleFocusOnButton } from "@/state/searchInputSlice";
import { useDispatch, useSelector } from "react-redux";
import { useIsDarkTheme } from "@/components/layout/useIsDarkTheme";
import { getLocationString } from "@/utils/text";

export const BestOutboundCard = ({ index, outbound, isLoadRates }) => {
    const dispatch = useDispatch();
    const { pickup, delivery, trailerType, pickupDate } = useSelector((state) => state.currentSearch);
    const { deliveryName, deliveryZip, avgPrice: rate, avgRPM: rpm, confidence: volume, distance } = outbound;
    const isDarkTheme = useIsDarkTheme();

    const handleClick = () => {
        dispatch(toggleFocusOnButton());
        const outboundNameSplit = deliveryName.split(", ") || ["", ""];
        const outboundLocation = { zip: deliveryZip, countryCode: "US", placeName: outboundNameSplit[0], stateCode: outboundNameSplit[1] };
        const newPickup = isLoadRates ? delivery : pickup;

        dispatch(
            setInputSearch({
                trailerType,
                pickupDate,
                pickup: newPickup,
                delivery: outboundLocation,
                outboundSearch: true,
                searchType: "load_rates",
                pickupQuery: getLocationString(newPickup, false),
                deliveryQuery: getLocationString(outboundLocation, false),
            }),
        );
    };

    return (
        <div
            className="flex flex-row h-[62px] border border-cm-p-outline rounded-lg bg-cm-p-surface hover:bg-cm-p-surface-hover cursor-pointer overflow-hidden"
            onClick={handleClick}
        >
            <div className="w-[22px] pt-2 bg-cm-p-container-green text-cm-p-on-container-green font-bold flex justify-center text-sm/[22px]">
                {index + 1}
            </div>
            <div className="flex flex-row w-[calc(100%-22px)] justify-between">
                <div className="flex flex-col  py-2 px-[10px]">
                    <div className="text-cm-p-text-primary text-sm/[22px]">{deliveryName}</div>
                    <div className="flex flex-row items-center">
                        <div className="flex">
                            <CurrencyText num={rate} round className="text-cm-p-text-primary text-sm leading-[22px] font-semibold" />
                        </div>
                        <div className="w-[1px] h-3 bg-cm-p-outline mx-3" />
                        <div className="flex">
                            <CurrencyText num={rpm} className="text-cm-p-text-primary text-sm leading-[22px] font-semibold" />
                        </div>
                    </div>
                </div>
                <div className="flex flex-col text-cm-p-text-secondary text-sm/[22px] py-2 justify-between pl-[10px] pr-3">
                    <div className="text-right">{distance} miles</div>
                    <div className="flex justify-end items-center">
                        <ConfidenceLevel level={volume === "high" ? 3 : volume === "medium" ? 2 : 1} isDarkTheme={isDarkTheme} />
                    </div>
                </div>
            </div>
        </div>
    );
};
